module.exports = __webpack_public_path__ + "static/img/login_background2.e1586daf.png";